import { cva } from '@vizit/theme';

export const gridClasses = cva({
  base: [
    'grid gap-8',
    'grid-cols-2', // Mobile: 2 columns
    'sm:grid-cols-3', // Small: 3 columns (640px+)
    'md:grid-cols-4', // Medium: 4 columns (768px+)
    'lg:grid-cols-5', // Large: 5 columns (1024px+)
    'xl:grid-cols-6', // Extra large: 6 columns (1280px+)
    '2xl:grid-cols-7', // 2XL: 7 columns (1536px+)
  ],
});

export const containerClasses = cva({
  base: '',
});

export const loadingCountClasses = cva({
  base: 'h-10 w-36 my-5',
});
